import classnames from 'classnames';
import React from 'react';

import { formatTimezoneIdToName } from '../utils/timezoneFormatter';

type Props = {
  className?: string;
  dataTestId?: string;
  timezone: string;
};

/**
 * Container for displaying name of timezone with proper word breaks (after each "/" character)
 * when there is not enough space to fully show it within single line
 * @param timezone id of timezone in IANA format
 */
export const TimezoneName: React.FC<Props> = ({ className, dataTestId = 'timezone', timezone }) => {
  const timezonePartialSubstrings = formatTimezoneIdToName(timezone).split('/').join('/<wbr />');

  return (
    <div
      className={classnames('timezone-info-name', className)}
      /* eslint-disable-next-line react/no-danger */
      dangerouslySetInnerHTML={{ __html: timezonePartialSubstrings }}
      data-test-id={dataTestId}
      data-test-value={timezone}
    />
  );
};
